import React, { useContext } from "react"

const ControlContext = React.createContext({
  projectCode: '',
  workbench: false,
  createUserCode: '',
  // 从表单某字段粘贴到另一个表单
  onCopyField: (dataCode: string)=> {},
  onPasteField: (dataCode: string)=> {}
})

interface ControlContextProps {
  workbench: boolean
  createUserCode: string
  projectCode: string
  onCopyField: (dataCode: string)=> void
  onPasteField: (dataCode: string)=> void
  children: React.ReactNode
}

export const useControlContext = ()=> {
  return useContext(ControlContext)
}

export const ControlProvider:React.FC<ControlContextProps> = ({ children, projectCode, createUserCode, workbench = false, onCopyField, onPasteField })=> {
  return (
    <ControlContext.Provider value={{workbench, createUserCode, projectCode, onCopyField, onPasteField}}>
      {children}
    </ControlContext.Provider>
  )
}
